import Vue from 'vue'
import VueRouter from 'vue-router'
// import loadSudoku from '@/assets/js/loadSudoku.js'
// import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'default',
    redirect: '/signIn'
  },
  {
    // 全局刷新
    path: '/blank',
    name: 'blank',
    component: () => import('../views/blank.vue')
  },
  {
    path: '/signIn',
    name: 'SignInPage',
    component: () => import('../views/SingInPage.vue')
    // beforeEnter: (to, from, next) => {
    //	// ...这样定义的守卫是该路由独享的，只有进入该路由时才会执行这个守卫。
    // }
  },
  {
    path: '/create',
    name: 'CreateAccountPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/CreateAccountPage.vue')
  },
  {
    path: '/forget',
    name: 'ForgetPswPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/ForgetPswPage.vue')
  },
  {
    path: '/verify',
    name: 'VerificationPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/VerificationPage.vue')
  },
  {
    path: '/register',
    name: 'RegisterPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/RegisterPage.vue')
  },
  // {
  // 	path: '/wait',
  // 	name: 'WaitingPage',
  // 	component: () => import(/* webpackChunkName: "about" */ '../views/WaitingPage.vue')
  // },
  {
    path: '/changePsw',
    name: 'ChangePswPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/ChangePswPage.vue')
  },
  {
    path: '/welcome',
    name: 'SuccessPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/SuccessPage.vue')
  },
  {
    path: '/signInsso',
    name: 'SingInSSOPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/SingInSSOPage.vue')
  },
  {
    path: '/ssoConfig',
    name: 'SSOConfigPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Configure.vue'),
    children: [
      {
        path: '/',
        redirect: '/configPage'
      },
      {
        path: '/configPage',
        name: 'configPage',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/SSOConfigPage.vue')
      },
      {
        path: '/waitingPage',
        name: 'SSOWaiting',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/SSOWaiting.vue')
      }
    ]
  }
]

const router = new VueRouter({
  routes
})
// 解决跳转重复路由报错问题
// const routerPush = router.push
// router.push = path => {
//   // 判断下当前路由是否就是要跳转的路由
//   if (router.currentRoute.fullPath.includes(path)) return
//   return routerPush.call(router, path)
// }
router.beforeEach((to, from, next) => {
  // if (to.path == '/welcome') {}
  next()
})

export default router
